var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25629_5005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 15.5001H20.4846C20.7991 15.5001 21.0751 15.293 21.1602 14.9922L23.9729 5.1921C24.0333 4.98083 23.9919 4.75388 23.8588 4.57833C23.7255 4.40333 23.5183 4.29998 23.2971 4.29998H6.15802L5.6554 2.04833C5.58398 1.72768 5.29834 1.5 4.96875 1.5H0.703125C0.314575 1.5 0 1.81317 0 2.19999C0 2.587 0.314575 2.89999 0.703125 2.89999H4.40442L6.94354 14.2749C6.19647 14.5983 5.67188 15.3386 5.67188 16.2001C5.67188 17.358 6.61816 18.3 7.78125 18.3H20.4846C20.8733 18.3 21.1877 17.987 21.1877 17.6C21.1877 17.2132 20.8733 16.9 20.4846 16.9H7.78125C7.39398 16.9 7.07813 16.5863 7.07813 16.2001C7.07813 15.8138 7.39398 15.5001 7.78125 15.5001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07812 20.3998C7.07812 21.5579 8.02441 22.4998 9.18768 22.4998C10.3508 22.4998 11.2971 21.5579 11.2971 20.3998C11.2971 19.2419 10.3508 18.2998 9.18768 18.2998C8.02441 18.2998 7.07812 19.2419 7.07812 20.3998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9689 20.3998C16.9689 21.5579 17.9152 22.4998 19.0782 22.4998C20.2415 22.4998 21.1876 21.5579 21.1876 20.3998C21.1876 19.2419 20.2415 18.2998 19.0782 18.2998C17.9152 18.2998 16.9689 19.2419 16.9689 20.3998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25629_5005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbag);
export default __webpack_public_path__ + "static/media/Shopping bag.eb16e8a230e6e3de1d78b00b0dc76e70.svg";
export { ForwardRef as ReactComponent };